import {
    SET_TAX_RATE,
    SET_INSTALL_YEAR,
    SET_TAX_ENTITY,
    SET_RESI_TOGGLE,
    SET_TAX_IPUTS,
} from './constants';

export const setTaxInputs = taxObligation => ({
    type: SET_TAX_IPUTS,
    taxObligation,
});

export const setInstallYear = installYear => ({
    type: SET_INSTALL_YEAR,
    installYear,
});

export const setTaxRate = taxRate => ({
    type: SET_TAX_RATE,
    taxRate,
});

export const setTaxEntity = taxEntity => ({
    type: SET_TAX_ENTITY,
    taxEntity,
});

export const setResiToggle = resiToggle => ({
    type: SET_RESI_TOGGLE,
    resiToggle,
});



// WEBPACK FOOTER //
// ./src/containers/common/tax/actions.js